export const defaultOnboardingConfig = {
    steps: [],
};
